import { get } from '@/api/request';

// 主页推荐列表
export const recommedList = (params) => get("recommedList", params);
